import { Outlet } from 'react-router-dom';
import { MeProvider } from '@/discord/context/MeContext';
import '@/discord/discord-scope.scss';

/**
 * Enveloppe de la catégorie « Discord » (gestion du bot support) dans l'espace Configuration.
 *
 * La classe `.discord-scope` (cf. styles/global.scss) isolera plus tard le CSS repris du
 * dashboard support (qui embarque un reset global qu'on NE veut PAS laisser fuiter dans le
 * panel). MeProvider fournit l'utilisateur courant dérivé de NOTRE auth (login Recube).
 */
export function DiscordScope() {
  return (
    <MeProvider>
      <div className="discord-scope">
        <Outlet />
      </div>
    </MeProvider>
  );
}
